import React, { useState, useEffect } from 'react'
import { StyledRadioElement } from '../search-filters-checkbox/search-filters-checkbox.styles'
import { useForm } from '../../forms/hocs/form.context'

export const SortOrderRadioButtons = () => {
    const { sortByOptions, sortBySelected, updateSortBySelected } = useForm()
    const [selectedValue, setSelectedValue] = useState('')

    useEffect(() => {
        setSelectedValue(sortBySelected ?? '')
    }, [sortBySelected])

    return (
        <>
            {sortByOptions.map(({ displayValue, value }) => {
                return (
                    <StyledRadioElement
                        key={value}
                        name={`sort-by-radio`}
                        id={`${value}-radio`}
                        className={`${value}-radio`}
                        reverse={true}
                        label={displayValue}
                        onChange={(e) => {
                            e.currentTarget.checked = true
                            const selected = e.currentTarget.value
                            setSelectedValue(selected)
                            updateSortBySelected(selected)
                        }}
                        value={String(value)}
                        checked={String(value) === selectedValue}
                    />
                )
            })}
        </>
    )
}
